import React, { Component } from "react";
import { Card, Row, Col, Typography, Modal, Space, Popconfirm, Tag, message, Divider, Spin } from "antd";
import { FileTextOutlined, PlusOutlined, EditOutlined, EyeOutlined, CalendarOutlined, UserOutlined } from "@ant-design/icons";
import ButtonItem from "../../../../Components/ButtonItem";
import { connect } from "react-redux";
import axios from "axios";
import InputItem from "../../../../Components/InputItem";
import AgregarBlog from "./AgregarBlog/AgregarBlog";
import EditarBlog from "./EditarBlog/EditarBlog";

const { Title, Text, Paragraph } = Typography;

const EMPRESA_AUTORIZADA = "66f196f27a90444bd4d4f533";

class Blog extends Component {
  state = {
    // Modal de visualización
    modalVisualizarVisible: false,
    selectedPostVisualizar: null,
    
    // Modal de agregar
    modalAgregarVisible: false,
    
    // Modal de editar
    modalEditarVisible: false,
    selectedPostEditar: null,
    
    // Lista de posts
    posts: [],
    postsFiltrados: [],
    loading: false,
    searchText: ""
  };

  componentDidMount() {
    if (EMPRESA_AUTORIZADA === this.props.empresaId) {
      this.cargarPostsAdmin();
    } else {
      this.cargarPosts();
    }
  }

  handleSearch = (value) => {
    const texto = value.toLowerCase();

    const filtrados = this.state.posts.filter(p => 
      p.titulo?.toLowerCase().includes(texto) ||
      p.descripcion?.toLowerCase().includes(texto) ||
      p.categoria?.toLowerCase().includes(texto) ||
      p.autor?.toLowerCase().includes(texto)
    );

    this.setState({
      searchText: value,
      postsFiltrados: filtrados
    });
  };

  cargarPosts = async () => {
    this.setState({ loading: true });
    try {
      const response = await axios.post(
        "blogs/selectPosts",
        {},
        this.props.headersToken
      );

      if (response.data.success === 2) {
        this.setState({ 
          posts: response.data.posts,
          postsFiltrados: response.data.posts
        });
      } else {
        message.error("Error al cargar los posts");
      }
    } catch (error) {
      console.error(error);
      message.error("Error al conectar con el servidor");
    } finally {
      this.setState({ loading: false });
    }
  };

  cargarPostsAdmin = async () => {
    this.setState({ loading: true });
    try {
      const response = await axios.post(
        "blogs/selectTodosPosts",
        {},
        this.props.headersToken
      );

      if (response.data.success === 2) {
        this.setState({ 
          posts: response.data.posts,
          postsFiltrados: response.data.posts
        });
      } else {
        message.error("Error al cargar los posts");
      }
    } catch (error) {
      console.error(error);
      message.error("Error al conectar con el servidor");
    } finally {
      this.setState({ loading: false });
    }
  };

  isEmpresaAutorizada = () => {
    return this.props.empresaId === EMPRESA_AUTORIZADA;
  };

  // ============================================
  // FUNCIONES PARA MODAL DE VISUALIZACIÓN
  // ============================================
  abrirModalVisualizar = (post) => {
    this.setState({
      modalVisualizarVisible: true,
      selectedPostVisualizar: post
    });
  };

  cerrarModalVisualizar = () => {
    this.setState({
      modalVisualizarVisible: false,
      selectedPostVisualizar: null
    });
  };

  // ============================================
  // FUNCIONES PARA MODAL DE AGREGAR
  // ============================================
  abrirModalAgregar = () => {
    this.setState({
      modalAgregarVisible: true
    });
  };

  cerrarModalAgregar = () => {
    this.setState({
      modalAgregarVisible: false
    });
  };

  handlePostAgregado = () => {
    this.cerrarModalAgregar();
    if (EMPRESA_AUTORIZADA === this.props.empresaId) {
      this.cargarPostsAdmin();
    } else {
      this.cargarPosts();
    }
  };

  abrirModalEditar = (post) => {
    this.setState({
      modalEditarVisible: true,
      selectedPostEditar: post
    });
  };

  cerrarModalEditar = () => {
    this.setState({
      modalEditarVisible: false,
      selectedPostEditar: null
    });
  };

  handlePostEditado = () => {
    this.cerrarModalEditar();
    if (EMPRESA_AUTORIZADA === this.props.empresaId) {
      this.cargarPostsAdmin();
    } else {
      this.cargarPosts();
    }
  };

  // ============================================
  // FUNCIONES PARA HABILITAR/DESHABILITAR
  // ============================================
  handleDeshabilitar = async (postId) => {
    this.setState({ loading: true });
    try {
      const response = await axios.post(
        'blogs/deshabilitarPost',
        { postId },
        this.props.headersToken
      );

      if (response.data.success === 2) {
        message.success('Post deshabilitado correctamente');
        this.cargarPostsAdmin();
      } else {
        message.error('Error al deshabilitar el post');
      }
    } catch (error) {
      console.error(error);
      message.error('Error al conectar con el servidor');
    } finally {
      this.setState({ loading: false });
    }
  };
  
  handleHabilitar = async (postId) => {
    this.setState({ loading: true });
    try {
      const response = await axios.post(
        'blogs/habilitarPost',
        { postId },
        this.props.headersToken
      );

      if (response.data.success === 2) {
        message.success('Post habilitado correctamente');
        this.cargarPostsAdmin();
      } else {
        message.error('Error al habilitar el post');
      }
    } catch (error) {
      console.error(error);
      message.error('Error al conectar con el servidor');
    } finally {
      this.setState({ loading: false });
    }
  };

  formatearFecha = (fecha) => {
    if (!fecha) return '';
    const date = new Date(fecha);
    return date.toLocaleDateString('es-ES', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  render() {
    const { 
      modalVisualizarVisible, 
      selectedPostVisualizar,
      modalAgregarVisible,
      modalEditarVisible,
      selectedPostEditar
    } = this.state;
    const { headersToken, empresaId } = this.props;
    const isAutorizada = this.isEmpresaAutorizada();

    return (
      <>
      <Spin spinning={this.state.loading} size="large"> 
        <div style={{ padding: '20px 0' }}>
          <div style={{ marginBottom: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <Title level={3}>
                <FileTextOutlined style={{ marginRight: 8 }} />
                Blog
              </Title>
              <Text type="secondary">
                Artículos, noticias y actualizaciones
              </Text>
            </div>
            {isAutorizada && (
              <ButtonItem 
                type="primary" 
                icon={<PlusOutlined />}
                onClick={this.abrirModalAgregar}
              >
                Nuevo Post
              </ButtonItem>
            )}
          </div>

          <div style={{ marginBottom: 20, maxWidth: 350 }}>
            <InputItem
              placeholder="Buscar post..."
              value={this.state.searchText}
              onChange={(e) => this.handleSearch(e.target.value)}
            />
          </div>

          <Row gutter={[24, 24]}>
            {this.state.postsFiltrados.map((post) => (
              <Col xs={24} sm={24} md={12} lg={8} key={post._id}>
                <Card
                  hoverable
                  bordered={false}
                  style={{ 
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    height: '100%'
                  }}
                >
                  {/* Imagen del post */}
                  <div 
                    style={{ 
                      position: 'relative',
                      paddingBottom: '56.25%',
                      height: 0,
                      overflow: 'hidden',
                      marginBottom: 16,
                      borderRadius: 8,
                      backgroundColor: '#f5f5f5',
                      cursor: 'pointer'
                    }}
                    onClick={() => this.abrirModalVisualizar(post)}
                  >
                    {post.imagenUrl ? (
                      <img 
                        src={post.imagenUrl} 
                        alt={post.titulo}
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover'
                        }}
                      />
                    ) : (
                      <div style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        textAlign: 'center',
                        color: '#bfbfbf'
                      }}>
                        <FileTextOutlined style={{ fontSize: 48 }} />
                      </div>
                    )}
                    <div style={{
                      position: 'absolute',
                      bottom: 0,
                      left: 0,
                      right: 0,
                      backgroundColor: 'rgba(0, 0, 0, 0.6)',
                      color: 'white',
                      padding: '8px 12px',
                      fontSize: 12
                    }}>
                      <EyeOutlined style={{ marginRight: 8 }} />
                      Click para leer más
                    </div>
                  </div>

                  {/* Información del post */}
                  <div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                      <Title level={5} style={{ marginBottom: 0, flex: 1 }}>
                        {post.titulo}
                      </Title>
                      {post.categoria && (
                        <Tag color="blue" style={{ marginLeft: 8 }}>{post.categoria}</Tag>
                      )}
                      {post.esAviso && (
                        <Tag color="red" style={{ marginLeft: 8 }}>Aviso</Tag>
                      )}
                    </div>

                    <Text type="secondary" style={{ display: 'block', marginBottom: 12, fontSize: 14 }}>
                      {post.descripcion}
                    </Text>

                    <div style={{ marginBottom: 16 }}>
                      {post.autor && (
                        <Text type="secondary" style={{ fontSize: 12, marginRight: 16 }}>
                          <UserOutlined style={{ marginRight: 4 }} />
                          {post.autor}
                        </Text>
                      )}
                      {post.fecha && (
                        <Text type="secondary" style={{ fontSize: 12 }}>
                          <CalendarOutlined style={{ marginRight: 4 }} />
                          {this.formatearFecha(post.fecha)}
                        </Text>
                      )}
                    </div>
                    
                    {/* Botones de acción */}
                    <Space style={{ width: '100%' }} direction="vertical">
                      <ButtonItem 
                        type="primary" 
                        icon={<EyeOutlined />}
                        onClick={() => this.abrirModalVisualizar(post)}
                        style={{ width: '100%' }}
                      >
                        Leer más
                      </ButtonItem>
                      
                      {isAutorizada && (
                        <div style={{ display: 'flex', gap: 8 }}>
                          <ButtonItem 
                            icon={<EditOutlined />}
                            onClick={() => this.abrirModalEditar(post)}
                            style={{ flex: 1 }}
                          >
                            Editar
                          </ButtonItem>
                          <Popconfirm
                            title={`¿Estás seguro de ${post.estado === 1 ? 'deshabilitar' : 'habilitar'} este post?`}
                            onConfirm={() => post.estado === 1 ? this.handleDeshabilitar(post._id) : this.handleHabilitar(post._id)}
                            okText="Sí"
                            cancelText="No"
                          >
                            {post.estado === 1 ? (
                              <ButtonItem 
                                danger
                                style={{ flex: 1 }}
                              >
                                Deshabilitar
                              </ButtonItem>
                            ) : (
                              <ButtonItem 
                                type="primary"
                                style={{ flex: 1 }}
                                verde
                              >
                                Habilitar
                              </ButtonItem>
                            )}
                          </Popconfirm>
                        </div>
                      )}
                    </Space>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>

          {/* Modal para visualizar el post completo */}
          <Modal
            title={null}
            visible={modalVisualizarVisible}
            onCancel={this.cerrarModalVisualizar}
            width="70%"
            style={{ top: 20 }}
            footer={[
              <ButtonItem 
                key="close" 
                type="primary" 
                onClick={this.cerrarModalVisualizar}
              >
                Cerrar
              </ButtonItem>
            ]}
          >
            {selectedPostVisualizar && (
              <div>
                {/* Imagen destacada */}
                {selectedPostVisualizar.imagenUrl && (
                  <img 
                    src={selectedPostVisualizar.imagenUrl} 
                    alt={selectedPostVisualizar.titulo}
                    style={{
                      width: '100%',
                      maxHeight: '400px',
                      objectFit: 'cover',
                      borderRadius: 8,
                      marginBottom: 24
                    }}
                  />
                )}

                {/* Título */}
                <Title level={2} style={{ marginBottom: 8 }}>
                  {selectedPostVisualizar.titulo}
                </Title>

                {/* Metadata */}
                <div style={{ marginBottom: 16 }}>
                  {selectedPostVisualizar.categoria && (
                    <Tag color="blue" style={{ marginRight: 8 }}>
                      {selectedPostVisualizar.categoria}
                    </Tag>
                  )}
                  {selectedPostVisualizar.autor && (
                    <Text type="secondary" style={{ marginRight: 16 }}>
                      <UserOutlined style={{ marginRight: 4 }} />
                      {selectedPostVisualizar.autor}
                    </Text>
                  )}
                  {selectedPostVisualizar.fecha && (
                    <Text type="secondary">
                      <CalendarOutlined style={{ marginRight: 4 }} />
                      {this.formatearFecha(selectedPostVisualizar.fecha)}
                    </Text>
                  )}
                </div>

                <Divider />

                {/* Descripción corta */}
                {selectedPostVisualizar.descripcion && (
                  <Paragraph style={{ fontSize: 16, fontStyle: 'italic', color: '#595959' }}>
                    {selectedPostVisualizar.descripcion}
                  </Paragraph>
                )}

                {/* Contenido completo */}
                <div 
                  style={{ 
                    fontSize: 15, 
                    lineHeight: 1.8,
                    whiteSpace: 'pre-wrap'
                  }}
                  dangerouslySetInnerHTML={{ __html: selectedPostVisualizar.contenido }}
                />
              </div>
            )}
          </Modal>

          {/* Modal para agregar post */}
          <AgregarBlog
            visible={modalAgregarVisible}
            onCancel={this.cerrarModalAgregar}
            onSuccess={this.handlePostAgregado}
            headersToken={headersToken}
            empresaId={empresaId}
          />

          {/* Modal para editar post */}
          <EditarBlog
            key={selectedPostEditar?._id} // Key único para forzar remontaje
            visible={modalEditarVisible}
            post={selectedPostEditar}
            empresaId={empresaId}
            headersToken={headersToken}
            onSuccess={this.handlePostEditado}
            onCancel={this.cerrarModalEditar}
          />
        </div>
      </Spin>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(Blog);